module.exports = __webpack_public_path__ + "static/media/3 hanya oni mask blue eyes .1280x1483.bbd3c533.webp";